/**
 * Vaste set iconen voor statussymbolen op dossiers (Batjoens-wens 12). Gedeeld door server (validatie)
 * en client (weergave + keuzelijst in de winkelinstellingen). Bewust tekstsymbolen i.p.v. een
 * icoonbibliotheek: zo ziet het eruit zoals de winkel het op papier en in SMART gewoon is (★ ? !).
 */
export const MARKERING_ICONEN = {
  ster: '★',
  vraagteken: '?',
  uitroepteken: '!',
  vlag: '⚑',
  euro: '€',
  klok: '⏱',
  vinkje: '✓',
  potlood: '✎',
  telefoon: '☎',
  huis: '⌂',
  driehoek: '▲',
  bol: '●',
} as const;

export type MarkeringIcoon = keyof typeof MARKERING_ICONEN;

export function isMarkeringIcoon(v: unknown): v is MarkeringIcoon {
  return typeof v === 'string' && Object.prototype.hasOwnProperty.call(MARKERING_ICONEN, v);
}

export function markeringSymbool(icoon: string): string {
  return isMarkeringIcoon(icoon) ? MARKERING_ICONEN[icoon] : '•';
}

export const KLEUR_RE = /^#[0-9a-fA-F]{6}$/;

/** Standaardsymbolen die elke winkel bij het eerste gebruik krijgt (Batjoens, bezoek Thomas okt 2026). */
export const STANDAARD_MARKERINGEN: { sleutel: string; naam: string; icoon: MarkeringIcoon; kleur: string; volgorde: number }[] = [
  { sleutel: 'technisch_plan', naam: 'Verkoper vraagt technisch plan', icoon: 'ster', kleur: '#D97706', volgorde: 1 },
  { sleutel: 'voorschot', naam: 'Voorschot opvolgen', icoon: 'vraagteken', kleur: '#2563EB', volgorde: 2 },
  { sleutel: 'opmeting', naam: 'Opmeting aangevraagd', icoon: 'uitroepteken', kleur: '#DC2626', volgorde: 3 },
];
